import { Immutable } from "@hookstate/core";
import { forwardRef, useMemo } from "react";
import { FilterTagButton } from "../../../../components/buttons/FilterTag";
import { MoneyIcon } from "../../../../components/icons/MoneyIcon";
import { LicenseTypeEntity } from "../../../../services/gc/types";
import { Option, BrowseTabType } from "../../../../types";
import { FilterTitle } from "../../../../components/filters/FilterTitle";
import { RadioFilter } from "../../../../components/filters/RadioFilter";

export const LICENSE_TYPE_ALL = "0";

interface LicenseTypeFilterProps {
  value: Immutable<string | undefined>;
  licenseTypes: LicenseTypeEntity[];
  onChange: (nextValue: string) => void;
  tab?: BrowseTabType;
  tinted?: boolean;
}
export function LicenseTypeFilter({
  value,
  licenseTypes,
  onChange,
  tab = BrowseTabType.comics,
  tinted,
}: LicenseTypeFilterProps) {
  const licenseTypeOptions: Option<string>[] = useMemo(() => {
    const baseOptions = [
      { label: "All", value: LICENSE_TYPE_ALL },
      ...licenseTypes.map((type) => ({
        label: type.display_name,
        value: "" + type.id,
      })),
    ];

    // Add Collectible and Download PDF options when Releases tab is selected
    if (tab === BrowseTabType.releases) {
      baseOptions.push({ label: "Collectible", value: "collectible" });
    }

    return baseOptions;
  }, [licenseTypes, tab]);

  return (
    <RadioFilter
      value={value}
      options={licenseTypeOptions}
      onChange={onChange}
      tinted={tinted}
    />
  );
}

interface LicenseTypeFilterTitleProps {
  isTrigger: boolean;
  licenseTypes: LicenseTypeEntity[];
  open?: boolean;
  value?: string;
}
export const LicenseTypeFilterTitle = forwardRef(
  (
    {
      isTrigger,
      licenseTypes,
      open,
      value,
      ...props
    }: LicenseTypeFilterTitleProps,
    ref,
  ) => {
    const licenseType = licenseTypes.find((type) => `${type.id}` == value);
    const filterValue =
      value === "collectible" ? "Collectible" : licenseType?.display_name;

    if (isTrigger) {
      return (
        <FilterTagButton
          icon={<MoneyIcon />}
          popoverRef={ref}
          text="Paywall"
          isFiltering={filterValue}
          {...props}
        />
      );
    }
    return <FilterTitle text="Paywall" open={open} icon={<MoneyIcon boxSize="24px" color="neutral.400" />} />;
  },
);
